import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/translation";

export const resources = {
  en,
} as const;

i18n.use(initReactI18next).init({
  compatibilityJSON: "v4",
  lng: "en",
  resources,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
